import { createRef, h } from "preact";
import { useLayoutEffect } from "preact/hooks";
import { createPortal } from "preact/compat";
import { useDispatch } from "react-redux";

import i18n from "../i18n.js";
import talentsApi from "../api/talents.js";

import Button from "./Button.jsx";
import Overlay from "./Overlay.jsx";
import RadioButtonGroup from "./RadioButtonGroup.jsx";
import { setGlobalError, updateTalentStateState } from "../store/";

export default function DefineStateDialog({
  onClose,
  onOpen,
  onChange,
  talent,
}) {
  const dispatch = useDispatch();

  const dialogRef = createRef();
  const overlayRef = createRef();

  useLayoutEffect(() => {
    // TODO: Some of this stuff should belong to Overlay and some should go into a
    //       general Dialog component
    const overlay = overlayRef.current.base;
    overlay.classList.add("overlay--open");
    const wrapper = dialogRef.current;
    wrapper.classList.add("dialog--open");
    wrapper.addEventListener(
      "animationend",
      () => {
        onOpen && onOpen();
      },
      { once: true } // Does not work in IE, but who cares
    );

    return () => {
      overlay.classList.add("overlay--exit");
      wrapper.classList.add("dialog--exit");

      return new Promise(function (resolve) {
        wrapper.addEventListener("animationend", resolve);
      });
    };
  }, []);

  async function changeState(event) {
    const state = event.target.value;
    if (talent.state === state) {
      return;
    }
    try {
      const change = await talentsApi.changeState(talent.id, state);
      dispatch(updateTalentStateState(change));
      onChange && onChange(change);
    } catch (err) {
      console.error(err);
      dispatch(setGlobalError(err.error));
    }
  }

  const states = ["contacted", "replied", "screened", "declined", "hired"].map(
    (value) => ({
      value,
      label: i18n.t(`component.talent_state.${value}`),
    })
  );

  return createPortal(
    <Overlay onClick={onClose} ref={overlayRef}>
      <section class="dialog dialog--md card" ref={dialogRef}>
        <h5 class="t-subtitle1 t-subtitle1--margin">
          {i18n.t("component.define_state_pullout.title")}
        </h5>
        <p class="t-body3">
          {i18n.t("component.define_state_pullout.description", {
            name: talent.data.name,
          })}
        </p>

        <div class="define-state-pullout__content mb-48">
          <RadioButtonGroup
            name="currentState"
            items={states}
            value={talent.state}
            onInput={changeState}
          />
        </div>

        <div class="dialog__buttonRow">
          <Button primary onClick={onClose}>
            {i18n.t("actions.ok")}
          </Button>
        </div>
      </section>
    </Overlay>,
    document.getElementById("modals")
  );
}
